<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    width="640"
    content-class="card confirm-close-dialog   "
  >
    <v-btn
      icon
      dark
      variant="text"
      class="dialog-close-btn"
      :disabled="saving"
      @click="$emit('update:modelValue', false)"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <div class="d-flex flex-column ga-4">
      <div class="header">
        <span class="title"> Wil je afsluiten? </span>
      </div>
      <div class="body">
        <span class="description">
          Je hebt niet-opgeslagen wijzigingen. Wil je deze opslaan voordat je
          afsluit?
        </span>
      </div>
      <div class="d-flex mt-6">
        <v-btn
          @click="$emit('save')"
          :loading="saving"
          :disabled="saving"
          variant="flat"
          class="btn text-white"
          color="var(--tertiary)"
        >
          Opslaan en afsluiten
        </v-btn>
        <v-btn
          variant="outlined"
          @click="$emit('discard')"
          :disabled="saving"
          class="btn btn-tertiary ml-4"
          color="var(--tertiary)"
        >
          Afsluiten zonder opslaan
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    // Keeps the dialog open with a spinner while "Opslaan en afsluiten" is in
    // flight. The checkfile drawer closes before it saves and leaves this off.
    saving: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "save", "discard"],
};
</script>
